export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20soft%20focus%20abstract%20fashion%20editorial%20background%20with%20gentle%20warm%20terracotta%20and%20sage%20green%20color%20wash%2C%20delicate%20fabric%20texture%20overlays%2C%20subtle%20organic%20shapes%20and%20flowing%20lines%2C%20modern%20minimalist%20aesthetic%2C%20warm%20neutral%20palette%20with%20hints%20of%20coral%2C%20sophisticated%20atmospheric%20mood%2C%20artistic%20composition%20with%20natural%20light%20gradients&width=1800&height=1000&seq=hero-bg-fresh-v2-18&orientation=landscape"
          alt="Superbuy Spreadsheet fashion product research background"
          title="Superbuy Spreadsheet - Product Research Platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-10 flex flex-col items-center text-center">
        <p className="text-white/70 text-sm md:text-base font-medium tracking-widest uppercase mb-6">
          Independent Educational Platform
        </p>

        <h1 className="font-heading text-white leading-tight max-w-5xl">
          <span className="block text-5xl md:text-7xl lg:text-8xl font-bold">
            Superbuy Spreadsheet
          </span>
          <span className="block text-2xl md:text-4xl lg:text-5xl italic font-normal mt-3 md:mt-5 text-white/90">
            The Ultimate Guide To Smarter Research
          </span>
        </h1>

        <p className="mt-6 md:mt-8 text-white/70 text-base md:text-lg max-w-[560px] leading-relaxed">
          Discover the latest Superbuy Spreadsheet resources, organized product categories, comparison tools, and expert shopping strategies designed to help you research products faster and make better decisions.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
          <a
            href="#categories"
            className="px-8 py-4 bg-background-50 text-foreground-950 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all duration-300"
          >
            Explore Superbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-white/15 backdrop-blur-sm border border-white/30 text-white rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-white/25 transition-all duration-300"
          >
            Visit Main Website
          </a>
        </div>

        {/* Trust Bar */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-14">
          {['Product Discovery', 'Category Research', 'Smart Comparison', 'Shopping Optimization'].map((item) => (
            <div key={item} className="flex items-center gap-2">
              <div className="w-5 h-5 rounded-full bg-accent-400/80 flex items-center justify-center">
                <i className="ri-check-line text-foreground-950 text-xs font-bold"></i>
              </div>
              <span className="text-white/80 text-sm font-medium whitespace-nowrap">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}